<template>
	<div class="video" :id="advanced.cssId"
	     :class="[advanced.cssClasses, responsiveClasses, {'lazy-load':lazyLoad}]"
	     :style="style" :data-vid="videoId" :data-autoplay="autoPlay" :data-showcontrols="showControls"
	     :data-lazyLoad="lazyLoad" :data-type="videoType" :data-loop="loop"
	     :data-width="width" :data-height="height">
		<template v-if="videoType === 'vimeo'">

<!--			<div style="padding:102.22% 0 0 0;position:relative;margin:auto;" :style="{width: ''}">-->
				<iframe class="lazyload"
				        :data-src="setVideoUrl"
				        frameborder="0" allow="autoplay; fullscreen; picture-in-picture"
				        allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;"
				        title="">
				</iframe>
<!--			</div>-->
		</template>
		<template v-else-if="lazyLoad">
			<div class="youtube-player video-inner" :data-youtube-id="videoId"
			     :id="'youtube_'+details.id">
				<iframe :width="width" :height="height"
				        :data-src="setVideoUrl" :style="innerStyle"
				        :srcdoc="srcdoc"
				        :class="['lazyloadx']"
				        frameborder="0"
				        allow="autoplay; modestbranding"
				        allowfullscreen></iframe>
			</div>
		</template>
		<iframe v-else
		        :width="width" :height="height"
		        :data-src="setVideoUrl" :style="innerStyle"
		        :class="['lazyload','video-inner']"
		        frameborder="0"
		        allow="autoplay; modestbranding"
		        allowfullscreen></iframe>
	</div>
</template>

<script>
import {borderProps, boxShadow, getPadding} from "@/modules/page-editor/src/utils/props";

export default {
	name: 'emailVideo',
	props: ['details'],
	computed: {
		basic() {
			return this.details.attributes.basic
		},
		advanced() {
			return this.details.attributes.advanced
		},
		responsive() {
			return this.details.responsive
		},
		responsiveClasses() {
			let c = '';
			if (!this.responsive) return '';
			if (!this.responsive.desktop) c = 'no-desktop';
			if (!this.responsive.mobile) c += ' no-mobile';
			if (!this.responsive.tablets) c += ' no-tablet';
			return c;
		},
		srcdoc() {
			let r = `<style>*{padding:0;margin:0;overflow:hidden}html,body{height:100%}img,span{position:absolute;width:100%;top:0;bottom:0;margin:auto}span{height:1.5em;text-align:center;font:48px/1.5 sans-serif;color:white;text-shadow:0 0 0.5em black}</style><a href=https://www.youtube.com/embed/${this.videoId}?autoplay=1><img src=https://img.youtube.com/vi/${this.videoId}/hqdefault.jpg alt=''><span>▶</span></a>`
			return r;
		},
		lazyLoad(){
			return this.basic.lazyLoad && this.basic.lazyLoad.booleanValue;
		},
		videoId() {
			return this.basic.videoId;
			// let url = this.basic.videoURL ? this.basic.videoURL : 'lRTtMcx6rSM';
			// var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
			// var match = url.match(regExp);
			// return (match && match[7].length == 11) ? match[7] : false;
		},
		videoThumb() {
			return this.basic.videoThumbnail; // return this.videoId ? `https://img.youtube.com/vi/${this.videoId}/sddefault.jpg` : '';
		},
		autoPlay() {
			return this.basic.autoPlay ? this.basic.autoPlay.booleanValue : false;
		},
		loop() {
			return this.basic.loop ? this.basic.loop.booleanValue : false;
		},
		showControls() {
			return this.basic.showControls ? this.basic.showControls.booleanValue : false;
		},
		videoType() {
			let url = this.basic.videoURL ? this.basic.videoURL : 'https://www.youtube.com/embed/lRTtMcx6rSM';
			if (url.indexOf('youtube')>=0) return 'youtube';
			if (url.indexOf('vimeo')>=0) return 'vimeo';
			return 'unknown';
		},
		vimeoVideoUrl() {
			let ap = this.autoPlay ? 1 : 0;
			let c = this.showControls ? 1 : 0;
			let u = `https://player.vimeo.com/video/126060304?autoplay=${ap}&loop=0&title=0&byline=${c}&portrait=0`;
			return u;
		},
		setVideoUrl() {
			let videoUrl = ''
			if (this.videoType==='vimeo' && this.basic.videoURL) {
				videoUrl = `https://player.vimeo.com/video/${this.videoId}?${this.autoPlay?'autoplay=1&muted=1':''}`;
				let x = this.showControls?'1':'0';
				videoUrl += `&controls=${x}&sidedock=${x}&title=${x}${this.loop?'&loop=1':''}`;
			}
			else {
				videoUrl = this.basic.videoURL ? `https://www.youtube.com/embed/${this.videoId}` : 'https://www.youtube.com/embed/lRTtMcx6rSM';
				videoUrl += '?rel=0'

				if (this.autoPlay) videoUrl += '&autoplay=1&mute=1';
				videoUrl += `&controls=${this.showControls?'1':'0'}`;
				if (this.loop) videoUrl += `&loop=1&playlist=${this.videoId}`
			}

			return videoUrl;
		},
		height() {
			let s = this.basic.size;
			if (this.videoType==="vimeo")
				return s && s.height ? s.height+'px' : null;
			else
				return s && s.height ? s.height + 'px' : null;//'auto';
		},
		width() {
			let s = this.basic.size;
			if (this.videoType==="vimeo")
				return s && s.width ? s.width : '100%';
			else
				return s && s.width ? s.width + 'px' : '100%';
		},
		innerStyle() {
			return {
				width: this.width,
				height: this.height,
			}
		},
		style() {
			// padding-top: 56.25%; */
			// height: 0;
			return {
				paddingTop: this.height ? null : '56.25%',
				width: Number.isInteger(this.width) ? this.width+'px' : this.width,
				height: this.height || 0,
				...borderProps(this.basic.border),
				margin: getPadding(this.basic.margin),
				boxShadow: boxShadow(this.advanced.shadows),
			}
		}
	},
}
</script>
